import { i18n, requestPlatform } from '@tencent/vb-web-base';
import { to } from '@tencent/vb-web-base-core';
import { NetworkError } from '@common/lib/error';
import { assign, pick } from 'lodash';
import api from '@loan/vb-node-loan/types/apiPlatform';

export type AdsChannelType =
  | 'wx'
  | 'mobile'
  | 'email'
  | 'push'
  | 'facebook'
  | 'whatsapp'
  | 'sms'
  | 'mail'
  | 'letter'
  | 'agree';
export type AdsChannels = {
  [key in AdsChannelType]: 0 | 1
};

export interface IAdOption {
  key: AdsChannelType
  text: string
  checked: boolean
}

/**
 * 获取用户信息
 */
export async function getUmUserInfo() {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    api.um.requestPlatformUmGetUmUserInfo()
  );
  if (err) {
    throw new NetworkError({ code: err?.status, message: $t('获取用户信息异常'), tag: 'userInfoError' });
  }
  if (respData.code !== 0) {
    throw new NetworkError({ code: respData.code, message: respData.message, tag: 'userInfoProblem' });
  }

  return respData.data;
}

/**
 * 通知数据
 */
export async function qryNoticeChannel() {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    api.um.requestPlatformUmQryNoticeChannel()
  );
  if (err) {
    throw new NetworkError({ code: err?.status, message: $t('系统繁忙，请稍后重试'), tag: 'noticeError' });
  }
  if (respData.code !== 0) {
    throw new NetworkError({ code: respData.code, message: respData.message, tag: 'noticeProblem' });
  }
  const arr = ['sms', 'email', 'push', 'mobile'];
  let allowedState = false;
  arr.forEach(item => {
    allowedState = allowedState || respData.data[item] === 1;
  });
  return allowedState;
}

export async function setNoticeChannel(form: Partial<AdsChannels>): Promise<boolean> {
  const { getT } = i18n;
  const $t = getT();
  const DEFAULT_ADSCHANNELS = {
    wx: 0,
    mobile: 0,
    email: 0,
    push: 0,
    facebook: 0,
    whatsapp: 0,
    sms: 0,
    mail: 0,
    letter: 0,
  };
  const ADSCHANNELS_KEYS = Object.keys(DEFAULT_ADSCHANNELS);

  const [respData, err] = await to(
    api.um.requestPlatformUmSetNoticeChannel(assign(DEFAULT_ADSCHANNELS, pick(form, ADSCHANNELS_KEYS))),
  );
  if (err) {
    throw new NetworkError({ code: err?.status, message: $t('系统繁忙，请稍后重试'), tag: 'noticeError' });
  }
  if (respData.code !== 0) {
    throw new NetworkError({ code: respData.code, message: respData.message, tag: 'noticeProblem' });
  }

  return respData.data.agree === 1;
}




// 检查是否设备绑定
export async function checkAssociation(): Promise<boolean> {
  const { getT } = i18n;
  const $t = getT();
  const [res, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data:{
        isDeviceBind:boolean
      }
    }>('/um/mgr/wxPay/checkAssociation', 'POST'),
  );
  if ( err || res.code !== 0) {
    return false
  }
  return res.data.isDeviceBind
 
}